import { useRef, useState, useEffect } from 'preact/hooks';
import styles from './Carousel.css';
import { renderIf } from '../../../utils/render.utils';

export default function Carousel({ items }) {
  const [currentItem, setCurrentItem] = useState(0);
  const [currentIndex, setCurrentIndex] = useState(currentItem);
  const carouselRef = useRef(null);
  const [scrollUsingDots, setScrollUsingDots] = useState(false);

  const handleDotClick = index => {
    setCurrentItem(index);
  };

  const showDots = items.length > 1;

  useEffect(() => {
    const items = carouselRef.current.querySelectorAll(
      "div[name='carousel-item']",
    );
    const selectedItem = items[currentItem];

    selectedItem?.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center',
    });
  }, [currentItem]);

  useEffect(() => {
    const handleScroll = () => {
      const carousel = carouselRef.current;
      const items = carousel.querySelectorAll("div[name='carousel-item']");
      const carouselRect = carousel.getBoundingClientRect();

      let closestIndex = 0;
      let closestDistance = Infinity;

      items.forEach((item, index) => {
        const itemRect = item.getBoundingClientRect();
        const distance = Math.abs(itemRect.left - carouselRect.left);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      setCurrentIndex(closestIndex);
    };

    const carousel = carouselRef.current?.querySelector('div');
    carousel.addEventListener('scroll', handleScroll);

    return () => {
      carousel.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div
      className={`${styles.carousel} ${!showDots ? styles.noDots : ''}`}
      ref={carouselRef}
    >
      <div className={styles.carouselScroll}>
        <div className={styles.carouselContainer}>
          {items.map((item, index) => (
            <div
              name={'carousel-item'}
              key={index}
              className={`${styles.carouselItem} ${
                index === currentIndex ? styles.active : ''
              }`}
            >
              {item}
            </div>
          ))}
        </div>
      </div>

      {renderIf(
        showDots,
        <div className={styles.dots}>
          {items.map((_, index) => (
            <span
              key={index}
              className={`${styles.dot} ${
                index === currentIndex ? styles.active : ''
              }`}
              onClick={() => handleDotClick(index)}
            />
          ))}
        </div>,
      )}
    </div>
  );
}
